var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hoc-dialog-loader',{attrs:{"loading":_vm.loading,"loading-message":_vm.loadingMessage}},[[(_vm.header)?_c('v-container',[_c('h2',[_vm._v(_vm._s(_vm.header))])]):_vm._e(),_c('div',[_vm._t("form")],2),(!_vm.hideRequiredLegend)?_c('small',{class:_vm.requiredLegendClass},[_vm._v("* indicates required field")]):_vm._e(),_vm._t("form-actions")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }